import { get } from "lodash";
import { ChangeOwnershipReasonCode } from "../../utils/code-converter";
import { Helpers } from "../../utils/helper";
import { Owner } from "../polymer/Owner.model";
import { ApplicationStart } from "./ApplicationStart.class";
import { ApplicationStep1, ReasonFormData } from "./ApplicationStep1.class";
import { MyInfo, MyInfoWithDOD } from "../polymer/MyInfo.model";
import { Occupier } from "../polymer/Occupier.model";
import { ReasonEnum } from "../enum/reason.enum";
import { StructureStatusEnum } from "../enum/structure-status.enum";
import { ApplicationStep2 } from "./ApplicationStep2.class";
import { ApplicationStep3 } from "./ApplicationStep3.class";
import { ApplicationStep4 } from "./ApplicationStep4.class";
import { ApplicationStep5 } from "./ApplicationStep5.class";
import { PolymerAxios } from "../../utils/axios";
import { AttendCompletionInPersonEnum } from "../enum/attend-completion-in-person.enum";
import { HoldingTypeEnum } from "../enum/holding-type.enum";
import { FlatRoomTypeEnum } from "../enum/flat-room-type.enum";
import { SolicitorTypeEnum } from "../enum/solicitor-type.enum";
import { OwnerTypeEnum } from "../enum/owner-type.enum";
import { API_ApplicationSaveDraft } from "../../utils/api";
import { HoldingFormData } from "../polymer/HoldingFormData.model";
import { convertRoleToStructureStatus } from "../../utils/form-helper";
import { OwnershipReasonEnum } from "../enum/ownership-reason.enum";
import { PolymerCrypto } from "../../utils/encryptor";
import { convertStepToPolymerStage } from "../../utils/polymer-stage-converter";

const getBooleanByValue = (value: string) => {
  if(value) {
     return value === "yes";
  }else{
    return undefined;
  }
}

export class SubmitDocuments {
  uuid: string | null;
  code?: string;
  required_option_checked: boolean;
  file_name?: string;
  document_type?: string;
  label?: string;
  key?: string;
  uinfin?: string;
  id?: string | null;
  file_size?: number | null;
  submitted_by?: string;
  received_date?: string;

  constructor(initial?: SubmitDocuments){
    this.id = get(initial, 'id', null);
    this.uuid = get(initial, 'uuid', null);
    this.code = get(initial, 'code', "");
    this.required_option_checked = get(initial, 'required_option_checked', true);
    this.file_name = get(initial, 'file_name', "");
    this.document_type = get(initial, 'document_type', "");
    this.label = get(initial, "label", "");
    this.uinfin = get(initial, "uinfin", "");
    this.key = get(initial, "key", "");
    this.file_size = get(initial, "file_size", null);
    this.submitted_by = get(initial, "submitted_by", "");
    this.received_date = get(initial, "received_date", "");
  }
}

export class SubmitFinancing {
  current_loan_type:string = "";
  current_loan_amount: number = 0;
  current_loan_date: string = "";
  new_loan_type: string ="";
  new_loan_amount: number;
  bank_code: string;
  bank_name: string;

  constructor(initial?: SubmitFinancing){
    this.current_loan_type = get(initial, 'current_loan_type', "");
    this.current_loan_amount = get(initial, 'current_loan_amount', 0);
    this.current_loan_date = get(initial, 'current_loan_date', "");
    this.new_loan_type = get(initial, 'new_loan_type', "");
    this.new_loan_amount = get(initial, 'new_loan_amount', 0);
    this.bank_code = get(initial, 'bank_code', "");
    this.bank_name = get(initial, 'bank_name', "");
  }
}
export class SubmitConveyancing {
  holding_type:string = "";
  valuation: string = "";
  estimated_market_value: string = "";
  proposed_same_solicitor: boolean = false;
  tenancy_in_common : SubmitConveyancingTenancyInCommon[] = [];
  legal_representation : SubmitConveyancingLegalRepresentation[] = [];
  constructor(initial?: SubmitConveyancing){
    this.holding_type = get(initial, 'holding_type', "");
    this.valuation = get(initial, 'valuation', "");
    this.estimated_market_value = get(initial, 'estimated_market_value', "");
    this.tenancy_in_common = get(initial,'tenancy_in_common', []);
    this.legal_representation = get(initial,'legal_representation', []);
    this.proposed_same_solicitor = get(initial, 'proposed_same_solicitor', false);
  }
}
export class SubmitConveyancingTenancyInCommon {
  owner_uinfin:string = "";
  share_percent: number = 0;
  constructor(initial?: SubmitConveyancingTenancyInCommon){
    this.owner_uinfin = get(initial, 'owner_uinfin', "");
    this.share_percent = get(initial, 'share_percent', 0);
  }
}

export class SubmitConveyancingLegalRepresentation {
  
  solicitor_type: SolicitorTypeEnum | undefined;
  owner_type: OwnerTypeEnum | undefined;
  
  hdb_legal_term_condition: boolean;
  conveyancing_same_solicitor: boolean;
  
  solicitor : SubmitConveyancingSolicitor;
  conveyancing_solicitor : SubmitConveyancingSolicitor;
  
  constructor(initial?: SubmitConveyancingLegalRepresentation){
    this.solicitor_type = get(initial, 'solicitor_type', undefined) || "" as any;
    this.owner_type = get(initial, 'owner_type', undefined);
    this.hdb_legal_term_condition = get(initial, 'hdb_legal_term_condition', false);
    this.conveyancing_same_solicitor = get(initial, 'conveyancing_same_solicitor', false);
    this.solicitor = get(initial, 'solicitor', new SubmitConveyancingSolicitor());
    this.conveyancing_solicitor = get(initial, 'conveyancing_solicitor', new SubmitConveyancingSolicitor());
  }

  generateCurrentSubmissionJson(initial: ApplicationStep3, owner_type: OwnerTypeEnum = OwnerTypeEnum.current){
    this.solicitor_type = initial.current_solicitor_type || "" as any; //default to shoe empty value
    this.owner_type = owner_type;
    this.hdb_legal_term_condition = initial.current.hdb_solicitor.tnc;
    if(initial.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor){
      this.conveyancing_same_solicitor = initial.current.hdb_solicitor.represented_same_solicitor;
    }
    if(initial.current_solicitor_type === SolicitorTypeEnum.private_solicitor){
      this.conveyancing_same_solicitor = initial.current.private_solicitor.represented_same_solicitor;
      this.solicitor = new SubmitConveyancingSolicitor({
        uen_of_law_firm: initial.current.private_solicitor.uen,
        name_of_law_firm: initial.current.private_solicitor.name_of_firm,
        email_of_solicitor: initial.current.private_solicitor.email_of_solicitor,
        
        block_house_number: initial.current.private_solicitor.block_house_number,
        street_name: initial.current.private_solicitor.street_name,
        level: initial.current.private_solicitor.level,
        unit_number: initial.current.private_solicitor.unit_number,
        postal_code: initial.current.private_solicitor.postal_code,
        building_name: initial.current.private_solicitor.building_name,
        telephone_number: initial.current.private_solicitor.telephone_number
      });
    }

    if(this.conveyancing_same_solicitor === true){
       this.conveyancing_solicitor = new SubmitConveyancingSolicitor({...this.solicitor});
    }else{
      this.conveyancing_solicitor = new SubmitConveyancingSolicitor({
        uen_of_law_firm: initial.current.conveyancing_private_solicitor.uen,
        name_of_law_firm: initial.current.conveyancing_private_solicitor.name_of_firm,
        email_of_solicitor: initial.current.conveyancing_private_solicitor.email_of_solicitor,

        block_house_number: initial.current.conveyancing_private_solicitor.block_house_number,
        street_name: initial.current.conveyancing_private_solicitor.street_name,
        level: initial.current.conveyancing_private_solicitor.level,
        unit_number: initial.current.conveyancing_private_solicitor.unit_number,
        postal_code: initial.current.conveyancing_private_solicitor.postal_code,
        building_name: initial.current.conveyancing_private_solicitor.building_name,
        telephone_number: initial.current.conveyancing_private_solicitor.telephone_number
      });

      if(this.hdb_legal_term_condition === true && this.solicitor_type === SolicitorTypeEnum.private_solicitor) {
        this.solicitor_type = SolicitorTypeEnum.private_mortgage_hdb_conveyancing_solicitor;
      }
    }
    
  }
  generateProposedSubmissionJson(initial: ApplicationStep3){
    
    this.solicitor_type = initial.proposed_solicitor_type || "" as any; //default to shoe empty value
    this.owner_type = OwnerTypeEnum.proposed;
    this.hdb_legal_term_condition = initial.proposed.hdb_solicitor.tnc;
    if(initial.proposed_solicitor_type === SolicitorTypeEnum.hdb_solicitor){
      this.conveyancing_same_solicitor = initial.proposed.hdb_solicitor.represented_same_solicitor;
    }
    if(initial.proposed_solicitor_type === SolicitorTypeEnum.private_solicitor){
      this.conveyancing_same_solicitor = initial.proposed.private_solicitor.represented_same_solicitor;
      this.solicitor = new SubmitConveyancingSolicitor({
        uen_of_law_firm: initial.proposed.private_solicitor.uen,
        name_of_law_firm: initial.proposed.private_solicitor.name_of_firm,
        email_of_solicitor: initial.proposed.private_solicitor.email_of_solicitor,

        block_house_number: initial.proposed.private_solicitor.block_house_number,
        street_name: initial.proposed.private_solicitor.street_name,
        level: initial.proposed.private_solicitor.level,
        unit_number: initial.proposed.private_solicitor.unit_number,
        postal_code: initial.proposed.private_solicitor.postal_code,
        building_name: initial.proposed.private_solicitor.building_name,
        telephone_number: initial.proposed.private_solicitor.telephone_number
      });
    }

    if(this.conveyancing_same_solicitor === true){
        this.conveyancing_solicitor = new SubmitConveyancingSolicitor({...this.solicitor});
    }else{
      this.conveyancing_solicitor = new SubmitConveyancingSolicitor({
        uen_of_law_firm: initial.proposed.conveyancing_private_solicitor.uen,
        name_of_law_firm: initial.proposed.conveyancing_private_solicitor.name_of_firm,
        email_of_solicitor: initial.proposed.conveyancing_private_solicitor.email_of_solicitor,

        block_house_number: initial.proposed.conveyancing_private_solicitor.block_house_number,
        street_name: initial.proposed.conveyancing_private_solicitor.street_name,
        level: initial.proposed.conveyancing_private_solicitor.level,
        unit_number: initial.proposed.conveyancing_private_solicitor.unit_number,
        postal_code: initial.proposed.conveyancing_private_solicitor.postal_code,
        building_name: initial.proposed.conveyancing_private_solicitor.building_name,
        telephone_number: initial.proposed.conveyancing_private_solicitor.telephone_number
      });

      if(this.hdb_legal_term_condition === true && this.solicitor_type === SolicitorTypeEnum.private_solicitor) {
        this.solicitor_type = SolicitorTypeEnum.private_mortgage_hdb_conveyancing_solicitor;
      }
    }
  }

  generateOutgoingSubmissionJson(initial: ApplicationStep3){
    
    this.solicitor_type = initial.outgoing_solicitor_type || "" as any; //default to shoe empty value
    this.owner_type = OwnerTypeEnum.outgoing;
    this.hdb_legal_term_condition = initial.outgoing.hdb_solicitor.tnc;
    if(initial.outgoing_solicitor_type === SolicitorTypeEnum.hdb_solicitor){
      this.conveyancing_same_solicitor = initial.outgoing.hdb_solicitor.represented_same_solicitor;
    }
    if(initial.outgoing_solicitor_type === SolicitorTypeEnum.private_solicitor){
      this.conveyancing_same_solicitor = initial.outgoing.private_solicitor.represented_same_solicitor;
      this.solicitor = new SubmitConveyancingSolicitor({
        uen_of_law_firm: initial.outgoing.private_solicitor.uen,
        name_of_law_firm: initial.outgoing.private_solicitor.name_of_firm,
        email_of_solicitor: initial.outgoing.private_solicitor.email_of_solicitor,

        block_house_number: initial.outgoing.private_solicitor.block_house_number,
        street_name: initial.outgoing.private_solicitor.street_name,
        level: initial.outgoing.private_solicitor.level,
        unit_number: initial.outgoing.private_solicitor.unit_number,
        postal_code: initial.outgoing.private_solicitor.postal_code,
        building_name: initial.outgoing.private_solicitor.building_name,
        telephone_number: initial.outgoing.private_solicitor.telephone_number
      });
    }

    if(this.conveyancing_same_solicitor === true){
        this.conveyancing_solicitor = new SubmitConveyancingSolicitor({...this.solicitor});
    }else{
      this.conveyancing_solicitor = new SubmitConveyancingSolicitor({
        uen_of_law_firm: initial.outgoing.conveyancing_private_solicitor.uen,
        name_of_law_firm: initial.outgoing.conveyancing_private_solicitor.name_of_firm,
        email_of_solicitor: initial.outgoing.conveyancing_private_solicitor.email_of_solicitor,

        block_house_number: initial.outgoing.conveyancing_private_solicitor.block_house_number,
        street_name: initial.outgoing.conveyancing_private_solicitor.street_name,
        level: initial.outgoing.conveyancing_private_solicitor.level,
        unit_number: initial.outgoing.conveyancing_private_solicitor.unit_number,
        postal_code: initial.outgoing.conveyancing_private_solicitor.postal_code,
        building_name: initial.outgoing.conveyancing_private_solicitor.building_name,
        telephone_number: initial.outgoing.conveyancing_private_solicitor.telephone_number
      });

      if(this.hdb_legal_term_condition === true && this.solicitor_type === SolicitorTypeEnum.private_solicitor) {
        this.solicitor_type = SolicitorTypeEnum.private_mortgage_hdb_conveyancing_solicitor;
      }
    }
  }

}

class SubmitConveyancingSolicitor{
  uen_of_law_firm:string = "";
  name_of_law_firm:string = "";
  email_of_solicitor:string = "";

  block_house_number             : string = "";
  street_name                    : string = "";
  level                          : string = "";
  unit_number                    : string = "";
  postal_code                    : string = "";
  building_name                  : string = "";
  telephone_number               : string = "";

  constructor(initial?: SubmitConveyancingSolicitor){
    this.uen_of_law_firm = get(initial, 'uen_of_law_firm', "");
    this.name_of_law_firm = get(initial, 'name_of_law_firm', "");
    this.email_of_solicitor = get(initial, 'email_of_solicitor', "");
    
    this.block_house_number             = get(initial, "block_house_number", "");
    this.street_name                    = get(initial, "street_name", "");
    this.level                          = get(initial, "level", "");
    this.unit_number                    = get(initial, "unit_number", "");
    this.postal_code                    = get(initial, "postal_code", "");
    this.building_name                  = get(initial, "building_name", "");
    this.telephone_number               = get(initial, "telephone_number", "");
  }
}

export class CooSubmission{
  main_applicant_uinfin: string;
  hdb_ref: string;
  confirm_attend_completion_person: AttendCompletionInPersonEnum | undefined;

  has_private_property: boolean | undefined;
  has_dispose_property: boolean | undefined;
  flat_type: FlatRoomTypeEnum | undefined;
  holding_type: HoldingTypeEnum | undefined;
  documents: SubmitDocuments[];
  excepted_documents: string[];

  additional_roles: MyInfoWithDOD[];

  financing_info: SubmitFinancing;

  conveyancing: SubmitConveyancing;
  address: string;
  change_ownership_reason?: any;

  owners?: any[]; //Owner with flatten fields;
  occupiers?: any[]; //Occupier with flatten fields;

  change_in_marital_status?: any = {};
  change_in_financial_circumstances?: any = {};
  demise_of_current_owner?: any = {};
  renunciation?: any = {};
  moving_out?: any = {};

  outgoing_owner_represented?: string;
  scheme_type: string;
  
  submit_date?: string;
  polymer_stage: string;

  applicant_submission_consent_version: string;
  applicant_conveyancing_consent_version: string;
  terms_and_conditions_pdf_version: string;

  constructor(initial?:any){
    this.main_applicant_uinfin = get(initial, 'main_applicant_uinfin', "")
    this.hdb_ref = get(initial, 'hdb_ref', "")
    this.confirm_attend_completion_person = get(initial, 'confirm_attend_completion_person', undefined )
    this.has_private_property = get(initial, 'has_private_property', undefined)
    this.has_dispose_property = get(initial, 'has_dispose_property', undefined)
    this.flat_type = get(initial, 'flat_type', undefined)
    this.holding_type = get(initial, 'holding_type', undefined)
    this.documents = get(initial, 'documents', [])
    this.excepted_documents = get(initial, 'excepted_documents', [])
    this.financing_info = get(initial, 'financing_info', new SubmitFinancing())
    this.conveyancing = get(initial, 'conveyancing', new SubmitConveyancing())
    this.address = get(initial, 'address', "")
    this.change_ownership_reason = get(initial, 'change_ownership_reason', undefined)
    this.owners = get(initial, 'owners', [])
    this.occupiers = get(initial, 'occupiers', [])
    this.change_in_marital_status = get(initial, 'change_in_marital_status', {})
    this.change_in_financial_circumstances = get(initial, 'change_in_financial_circumstances', {})
    this.demise_of_current_owner = get(initial, 'demise_of_current_owner', {})
    this.renunciation = get(initial, 'renunciation', {})
    this.moving_out = get(initial, 'moving_out', {})
    this.outgoing_owner_represented = get(initial, 'outgoing_owner_represented', "")
    this.scheme_type = get(initial, 'scheme_type', "");
    this.additional_roles = get(initial, 'additional_roles', []);
    this.submit_date = get(initial, 'submit_date', '')
    this.polymer_stage = get(initial, 'polymer_stage', '')
    this.applicant_submission_consent_version = get(initial, 'applicant_submission_consent_version', '')
    this.applicant_conveyancing_consent_version = get(initial, 'applicant_conveyancing_consent_version', '')
    this.terms_and_conditions_pdf_version = get(initial, 'terms_and_conditions_pdf_version', '')
  }

  setApplicantSubmissionConsentVersion(version: string) {
    this.applicant_submission_consent_version = version;
  }

  setApplicantConveyancingConsentVersion(version: string) {
    this.applicant_conveyancing_consent_version = version;
  }
  
  setTermsAndConditionsPdfVersion(version: string) {
    this.terms_and_conditions_pdf_version = version;
  }

  setSchemeType(schemeType: string){
    this.scheme_type = schemeType;
 }

  setMainApplicantUinfin(uinfin: string){
    this.main_applicant_uinfin = PolymerCrypto.encryption(uinfin);
  }

  setOutgoingOwnerRepresented(uinfin: string){
    this.outgoing_owner_represented = uinfin;
  }

  setApplicationStartForm(initial?: ApplicationStart){
    this.hdb_ref = initial?.selected_hdb_property?.hdb_ref ? initial?.selected_hdb_property?.hdb_ref : ""; //!TO REVIEW
    this.address = initial?.selected_hdb_property?.address ?? "";
    this.holding_type = initial?.selected_hdb_property?.holding_type ?? undefined;
    this.flat_type = initial?.selected_hdb_property?.flat_type ?? undefined;
    this.additional_roles = initial?.selected_hdb_property?.additional_roles ?? [];
    this.polymer_stage = initial?.polymer_stage ?? "A1";
  }

  setApplicationStep1Form(initial?: ApplicationStep1){
    
    this.has_private_property = initial?.household.check_has_private_property;
    this.has_dispose_property = initial?.household.check_has_dispose_property;
    this.change_ownership_reason = ChangeOwnershipReasonCode.find(e=>e.change_ownership_reason_value === initial?.reason?.change_ownership_reason!)?.code; 

    const currentOwnerNricArr = initial?.household.owners.map(e=>e.myinfo.uinfin); 
    const currentOccupierNricArr = initial?.household.occupiers.map(e=>e.myinfo.uinfin); 

    //create a list of owners including incoming, retaining and outgoing. So first loop will loop through the incoming household owner. Then second loop will loop current owners
    let combined_owners:any[] = [];
    const incomingOwnersNricArr = initial?.household.incoming_owners.map(e=>e.myinfo.uinfin);

    initial?.household.incoming_owners?.forEach(e=> {
      if(currentOccupierNricArr?.includes(e.myinfo.uinfin)){
        //CURRENT OCCUPIER TO INCOMING OWNER
        combined_owners.push(new SubmissionOwner({...e, is_applicant:true,structure_status: StructureStatusEnum.incoming}).getJson());
      }
      else{
        combined_owners.push(new SubmissionOwner(e).getJson());
      }
    });
    
    //When current owners nric is not inlucded in the nric arr of proposed incoming owners, then add as outgoing.
    initial?.household.owners?.forEach(e=> {
      if(!incomingOwnersNricArr?.includes(e.myinfo.uinfin)){
        combined_owners.push(new SubmissionOwner({...e,is_applicant:false, structure_status: StructureStatusEnum.outgoing, structure_order:""}).getJson());
      }
    });


    //create a list of occupiers including incoming, retaining and outgoing. So first loop will loop through the incoming household occupier. Then second loop will loop current occupiers

    let combined_occupiers:any[] = [];
    const incomingOccupierNricArr = initial?.household.incoming_occupiers.map(e=>e.myinfo.uinfin);
    initial?.household.incoming_occupiers?.forEach(e=> {
      if(currentOwnerNricArr?.includes(e.myinfo.uinfin)){
        //CURRENT OWNER TO INCOMING OCCUPIER
        combined_occupiers.push(new SubmissionOccupier({...e,  structure_status: StructureStatusEnum.incoming}).getJson());
      }
      else{
        combined_occupiers.push(new SubmissionOccupier(e).getJson());
      }

    });

     //When current occupiers nric is not inlucded in the nric arr of proposed incoming occupiers, then add as outgoing.
     initial?.household.occupiers?.forEach(e=> {
      if(!incomingOccupierNricArr?.includes(e.myinfo.uinfin)){
        combined_occupiers.push(new SubmissionOccupier({...e, structure_status: StructureStatusEnum.outgoing}).getJson());
      }
    });

    //Add additional_roles to owner when save draft and submit
    let allOwners = [...combined_owners.map(e => PolymerCrypto.decryption(e.uinfin))];
    let additionalRole = this.additional_roles.filter(e=> !allOwners.includes(e.uinfin)).map(e=>{
      let structure_status = convertRoleToStructureStatus(e.role_name);
      return new SubmissionOwner({...e, is_applicant:false, structure_status, myinfo: new MyInfo({...e})}).getJson();
    })
        
    this.owners = [...combined_owners, ...additionalRole];
    this.occupiers = combined_occupiers;

    const currentHouseholdStructureStatuses = [StructureStatusEnum.outgoing, StructureStatusEnum.retaining];
    let currentOwners = initial?.household?.owners ?? [];
    currentOwners = currentOwners.filter(item => item.role_name === "Lessee").concat(currentOwners.filter(item => item.role_name !== "Lessee")) ?? [];

    for(let i = 0; i < currentOwners.length; i++) {
      const submissionOwner = this.owners.find(item => currentHouseholdStructureStatuses.includes(item.structure_status) && (PolymerCrypto.decryption(item.uinfin) === currentOwners[i].myinfo.uinfin || item.name === currentOwners[i].myinfo.name));
      if(submissionOwner) {
        submissionOwner.current_structure_order = `L${i + 1}`;
      }
    }
    
    if(initial?.reason.reason === ReasonEnum.marital_status_reason_value){
      //In change of marital status got moving out due to marraige which has duplication question in A1. So if this is the reason thn add date of marraige to both of the obj.
      if(initial.reason.change_ownership_reason === OwnershipReasonEnum.moving_out_due_to_marriage){
        this.moving_out = new MovingOutOwner(initial?.reason).getJson();
      }
      this.change_in_marital_status = new ChangeInMaritalStatusReason(initial?.reason).getJson();
      this.outgoing_owner_represented = initial?.reason?.registrar_uinfin;
    }
    else if(initial?.reason.reason === ReasonEnum.financial_circumstances_reason_value){
      this.change_in_financial_circumstances = new ChangeInFinancialCircumstancesReason(initial?.reason).getJson();
    }
    else if(initial?.reason.reason === ReasonEnum.demise_current_owner_reason_value){
      this.demise_of_current_owner = new DemiseOfCurrentOwnerReason(initial?.reason).getJson();
    }
    else if(initial?.reason.reason === ReasonEnum.loss_of_citizenship_reason_value){
      this.renunciation = new RenunciationReason(initial?.reason).getJson();
    }
    else if(initial?.reason.reason === ReasonEnum.owner_moving_out_reason_value){
      this.moving_out = new MovingOutOwner(initial?.reason).getJson();
    }
    
  }

  setApplicationStep2Form(initial: ApplicationStep2) {
    this.financing_info = new SubmitFinancing({
      //NOTE: Current mean "OLD" loan, new mean "use selected in the step 2 application";
      current_loan_type : initial.current_loan_type ?? "",
      current_loan_date : initial.current_loan_date,
      current_loan_amount : Number(initial.current_loan_amount) ?? 0,
      
      new_loan_type : initial.new_loan_type ?? "",
      new_loan_amount: Number(initial.new_loan_amount) ?? 0,
      bank_code: initial.bank_code,
      bank_name: initial.bank_name,
    })
  }

  setApplicationStep3Form(initial: ApplicationStep3) {
    this.confirm_attend_completion_person = initial.attend_hdb_in_person ? "Yes" : "No";


    //Process tenancy_in_common, if holding_type not tenancy_in_common, then assign empty array. Else process tenancy in common
    let process_tenancy_in_common:SubmitConveyancingTenancyInCommon[] = [];

    if(initial.holding_type === HoldingTypeEnum.tenancy_in_common ){
      process_tenancy_in_common = initial.tenancy_in_common.map(e=>{
        return new SubmitConveyancingTenancyInCommon({owner_uinfin:e.user.myinfo.uinfin, share_percent: e?.shares ? Number(e?.shares) : 0})
      })
    }

    //Process legal_representation
    let current_legal_representation: SubmitConveyancingLegalRepresentation = new SubmitConveyancingLegalRepresentation();
    current_legal_representation.generateCurrentSubmissionJson(initial);
    
    let proposed_legal_representation: SubmitConveyancingLegalRepresentation = new SubmitConveyancingLegalRepresentation();
    proposed_legal_representation.generateProposedSubmissionJson(initial);
    
    this.conveyancing = new SubmitConveyancing({ 
      holding_type: initial.holding_type ?? "", 
      valuation:initial.valuation ?? "",
      estimated_market_value: initial.estimated_market_value ?? "",
      tenancy_in_common: process_tenancy_in_common,
      legal_representation: [current_legal_representation,proposed_legal_representation],
      proposed_same_solicitor: initial.proposed_same_solicitor ?? false
    })

  }

  setApplicationStep4Form(initial: ApplicationStep4) {
    this.documents = initial.file_items.map(file=>{
      //NOTE: required_option_checked not track from application-step-4;
      let fileType = "";
      if(file?.file_content?.file_name){
        const fileNameSplitArray = file?.file_content?.file_name.split('.');
        fileType = fileNameSplitArray[fileNameSplitArray.length - 1];
      }
      return new SubmitDocuments({uuid:file.file_id.toString(), code: file.code, file_name:file.file_content?.file_name ,label: file.label,document_type: fileType, required_option_checked:true, key: file.key, file_size: file.file_content.size});
    });
    this.excepted_documents = initial.excepted_documents;
  }

  setApplicationStep5Form(initial: ApplicationStep5) {
    //NOTE: add feature for application 5 if needed
  }

  getJson(){
    return this;
  }

  async performSaveDraft(uinfin: string, polymerStage: string, applicationId?: string, singpassToken?:string): Promise<{application_id?: string, success: boolean}> {
    // "this" needs to have the "change_ownership_reason" property, otherwise the backend will throw an error
    try{      
      const submittingData = {
        ...this,
        ...(polymerStage ? {polymer_stage: polymerStage} : {}),
        ...(applicationId ? {application_id: applicationId} : {}),
      };

      const response = await PolymerAxios(uinfin, singpassToken).post(API_ApplicationSaveDraft, submittingData);
      return {
        application_id: response.data?.application_id ?? undefined,
        success: true,
      }
    }catch(error){
      return {
        application_id: undefined,
        success: false,
      }
    }
  }
  
  mapMainApplicantToOwnerPayload(holdingFormValues:HoldingFormData){
    
    let current_owners:any[] = [...this.owners??[]];
    let current_occupiers:any[] = [...this.occupiers??[]];

    let mainApplicant:any = holdingFormValues.holding_owners[0] ?? holdingFormValues.holding_occupiers[0];

    const isAdditionalInCurrent = current_owners?.some(e=> PolymerCrypto.decryption(e.uinfin) === mainApplicant?.myinfo?.uinfin) || current_occupiers?.some(e=> PolymerCrypto.decryption(e.uinfin) === mainApplicant?.myinfo.uinfin);

    /**
     * Check if additional role applicant is included in current owners or occupiers. If yes then direcly map the info to owner.
     * Else create new owner and include it to existing owner array.
     */
    if(isAdditionalInCurrent){
      if(holdingFormValues.holding_owners.length > 0){
        let formated_owners = current_owners.map(e=>{
          if(PolymerCrypto.decryption(e.uinfin) === mainApplicant.myinfo.uinfin){
            const newMyinfo = new MyInfo({...mainApplicant.myinfo});
            const spouse = e.spouse ? PolymerCrypto.decryption(e.spouse) : "";
            return new SubmissionOwner({...e, owner: new Owner({...e}), myinfo: new MyInfo({...e, ...newMyinfo}), spouse: spouse}).getJson();
          }
          else{
            return e;
          }
        })      
        this.owners = formated_owners;
      } else if(holdingFormValues.holding_occupiers.length > 0) {
        let formated_owners = current_occupiers.map(e=>{
          if(PolymerCrypto.decryption(e.uinfin) === mainApplicant.myinfo.uinfin){
            const spouse = e.spouse ? PolymerCrypto.decryption(e.spouse) : "";
            return new SubmissionOccupier({...mainApplicant, spouse: spouse, structure_status: mainApplicant.structure_status ?? StructureStatusEnum.outgoing}).getJson();
          }
          else{
            return e;
          }
        })
    
        this.occupiers = formated_owners;
      }    
    }
    else{
      const additionalOwner = new SubmissionOwner({...mainApplicant}).getJson();
      this.owners = this.owners?.concat(additionalOwner);
    }
  
  }

  mapMainApplicantToOwnerSaveDraft(start_application: ApplicationStart,holdingFormValues?:HoldingFormData){

    const isCurrentApplicant = start_application.selected_hdb_property?.owners.some(e=>e.uinfin === PolymerCrypto.decryption(this.main_applicant_uinfin)) || start_application.selected_hdb_property?.occupiers.some(e=>e.uinfin === PolymerCrypto.decryption(this.main_applicant_uinfin));
    const additionalApplicant = start_application.selected_hdb_property?.additional_roles.find(e=> e.uinfin === PolymerCrypto.decryption(this.main_applicant_uinfin));
    const isIncluded = this.owners?.some(e=> PolymerCrypto.decryption(e.uinfin) === PolymerCrypto.decryption(this.main_applicant_uinfin));
    /**
     * To check current owner array first, and also to check whether it is included.
     */
    if(!isCurrentApplicant && additionalApplicant && !isIncluded){
      const structure_status = convertRoleToStructureStatus(additionalApplicant.role_name);
      console.log("holdingFormValues_3: ", holdingFormValues);
      let mainApplicant:any = holdingFormValues ? (holdingFormValues.holding_owners[0] ?? holdingFormValues.holding_occupiers[0]) : "";
      console.log("mainApplicant: ", mainApplicant);
      const myinfo = mainApplicant === "" ? new MyInfo({...additionalApplicant}) : new MyInfo({...mainApplicant.myinfo});
      
      console.log("myinfo: ", myinfo);
      this.owners = this.owners?.concat(new SubmissionOwner({...additionalApplicant, structure_status:structure_status, myinfo: myinfo}).getJson());
    }
  }
}


export class ChangeInMaritalStatusReason extends ReasonFormData{
  constructor(initial?: ReasonFormData){
    super(initial);
  }

  getJson(){
    return {
      situation: this.change_ownership_reason,
      have_final_judgement: getBooleanByValue(this.have_final_judgement),
      final_judgement_date: getBooleanByValue(this.have_final_judgement) ? this.final_judgement_date : "",
      date_of_marriage: this.date_of_marriage,
      due_date_complete_application: this.date_of_court_order,
      consideration_amount_stated: Helpers.formatStringToNumber(this.amount_stated_in_court_order),
      cpf_refund_outgoing_owner: this.cpf_refund,
      confirm_remove_owner_singpass_login: this.submit_content
    }
  }
}
export class DemiseOfCurrentOwnerReason extends ReasonFormData{
  constructor(initial?: ReasonFormData){
    super(initial);
  }

  getJson(){
    return {
      have_related_document: this.has_administration_items,
      date_of_dead: this.death_date,
      listed_beneficiaries_is_proposed_owners: this.is_beneficiary_proposed_owners ? this.is_beneficiary_proposed_owners.toString() : null
    }
  }
}
export class ChangeInFinancialCircumstancesReason extends ReasonFormData{
  

  constructor(initial?: ReasonFormData){
    super(initial);
  }

  getJson(){
    return {
      have_outstanding_bank_loan: this.has_outstanding_loan,
      bank_loan_amount: this.outstanding_loan_amount ? Helpers.formatStringToNumber(this.outstanding_loan_amount) : "",
    }
  }
}

export class RenunciationReason extends ReasonFormData{
  constructor(initial?: ReasonFormData){
    super(initial);
  }

  getJson(){
    return {
      date_of_renunciation: this.date_of_renunciation,
    }
  }
}
export class MovingOutOwner extends ReasonFormData{
  constructor(initial?: ReasonFormData){
    super(initial);
  }

  getJson(){
    return {
      situation: this.change_ownership_reason,
      date_of_marriage : this.date_of_marriage,
    }
  }
}


class SubmissionOccupier{
  owner?: Occupier;
  myinfo?: MyInfo;
  

  constructor(initial?:Occupier){

    //Exclude myinfo from Owner obj
    const {myinfo, own_property, is_related, ...newObj} = {...initial};
    this.owner = new Occupier({...newObj});

    this.myinfo = get(initial,"myinfo",new MyInfo());
    
  }
  
  getJson(){
    const {own_property, myinfo, ...rest} = {...this.owner, ...this.myinfo, spr_obtained_date: ""};

    rest.is_related = rest.relationship_with_owner !== "";
    rest.relationship_with_owner = rest.relationship_with_owner ? rest.relationship_with_owner : "OT";
    rest.uinfin = PolymerCrypto.encryption(rest?.uinfin);
    rest.spouse = PolymerCrypto.encryption(rest?.spouse);
    rest.email = PolymerCrypto.encryption(rest?.email);
    rest.mobile_no = PolymerCrypto.encryption(rest?.mobile_no);
    rest.dod = rest?.dod && rest?.dod?.length > 0 ? rest?.dod : "0001-01-01";

    return rest;
  }

}

class SubmissionOwner{
  
  is_applicant?: boolean;
  owner?: Owner;
  myinfo?: MyInfo;
  

  constructor(initial?:any){
    this.is_applicant = get(initial, "is_applicant", true);

    //Exclude myinfo from Owner obj
    const {myinfo, ...newObj} = {...initial} as Owner;
    this.owner = new Owner({...newObj});

    this.myinfo = get(initial,"myinfo",new MyInfo());
  }
  
  getJson(){
    //remove myinfo
    const {own_property, myinfo, ...rest} = {...this.owner, ...this.myinfo, is_applicant: this.is_applicant};
    rest.is_related = !!rest.is_related;
    let relationship;
    if (rest.relationship_with_owner) {
      relationship = rest.relationship_with_owner;
    } else {
      relationship = rest.structure_order === "L1" ? "LE" : "OT";
    }
    rest.relationship_with_owner = relationship;
  
    rest.uinfin = PolymerCrypto.encryption(rest?.uinfin);
    rest.spouse = PolymerCrypto.encryption(rest?.spouse);
    rest.email = PolymerCrypto.encryption(rest?.email);
    rest.mobile_no = PolymerCrypto.encryption(rest?.mobile_no);
    rest.dod = rest?.dod && rest?.dod?.length > 0 ? rest?.dod : "0001-01-01";

    return rest
  }

}



  // owner?: Pick<Owner,"children_care_and_control" | "relationship_with_owner" | "structure_status" | "own_property" | "is_related">
  // myinfo?: Pick<Owner, "myinfo">

  